import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

const API = '/api';
const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
const errOf = (e: any, d: string) => (e && e.response && e.response.data && e.response.data.detail) || d;
const card: any = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, marginBottom: 16 };
const inp: any = { padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit' };
const btn: any = { padding: '6px 12px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' };

// Konta bankowe firmy do platnosci przelewem (wspolne dla wszystkich uzytkownikow firmy)
export default function BankAccountsCard() {
  const [list, setList] = useState<any[] | null>(null);
  const [hidden, setHidden] = useState(false);
  const [form, setForm] = useState<any>({ id: '', number: '', description: '', is_default: false });
  const [msg, setMsg] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const load = () => {
    axios.get(API + '/settings/bank-accounts', { headers: auth() })
      .then((r: any) => setList(r.data.accounts || []))
      .catch((e: any) => { if (e && e.response && (e.response.status === 403 || e.response.status === 401)) setHidden(true); else setList([]); });
  };
  useEffect(() => { load(); }, []);
  if (hidden) return null;
  const reset = () => setForm({ id: '', number: '', description: '', is_default: false });
  const save = () => {
    if (!form.number.trim()) { setMsg({ ok: false, text: '✕ Podaj numer konta.' }); return; }
    setBusy(true); setMsg(null);
    const body = { number: form.number, description: form.description, is_default: form.is_default };
    const req = form.id ? axios.put(API + '/settings/bank-accounts/' + form.id, body, { headers: auth() }) : axios.post(API + '/settings/bank-accounts', body, { headers: auth() });
    req.then((r: any) => { setList(r.data.accounts || []); setMsg({ ok: true, text: form.id ? '✓ Zapisano zmiany.' : '✓ Dodano konto.' }); reset(); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zapisać.') }))
      .finally(() => setBusy(false));
  };
  const del = (a: any) => {
    if (!window.confirm('Usunąć konto ' + a.number + (a.description ? ' (' + a.description + ')' : '') + '?\n\nZamówienia, w których było wybrane, zachowają ten numer.')) return;
    axios.delete(API + '/settings/bank-accounts/' + a.id, { headers: auth() })
      .then((r: any) => { setList(r.data.accounts || []); setMsg({ ok: true, text: '✓ Usunięto konto.' }); if (form.id === a.id) reset(); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się usunąć.') }));
  };
  const setDefault = (a: any) => {
    axios.put(API + '/settings/bank-accounts/' + a.id, { number: a.number, description: a.description, is_default: true }, { headers: auth() })
      .then((r: any) => { setList(r.data.accounts || []); setMsg({ ok: true, text: '✓ Konto domyślne zmienione.' }); })
      .catch((e: any) => setMsg({ ok: false, text: '✕ ' + errOf(e, 'Nie udało się zmienić.') }));
  };
  return (
    <div style={card}>
      <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>Konta bankowe</div>
      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 12 }}>Konta do płatności przelewem — do wyboru przy dodawaniu i edycji zamówienia. Wspólne dla wszystkich użytkowników firmy.</div>
      {list === null ? <div style={{ fontSize: 12, color: '#6b7280' }}>⏳ Wczytywanie…</div> : null}
      {list && list.length === 0 ? <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>Brak kont — dodaj pierwsze poniżej.</div> : null}
      {(list || []).map((a: any) => (
        <div key={a.id} style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', padding: '8px 0', borderBottom: '1px solid #f1f5f9' }}>
          <div style={{ flex: '1 1 260px' }}>
            <div style={{ fontFamily: 'monospace', fontSize: 13, fontWeight: 600 }}>{a.number}</div>
            <div style={{ fontSize: 12, color: '#6b7280' }}>{a.description || 'bez opisu'}</div>
          </div>
          {a.is_default ? <span style={{ fontSize: 11, color: '#15803d', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '2px 8px' }}>domyślne</span>
            : <button onClick={() => setDefault(a)} style={btn}>Ustaw jako domyślne</button>}
          <button onClick={() => { setForm({ id: a.id, number: a.number, description: a.description || '', is_default: !!a.is_default }); setMsg(null); }} style={btn}>✏️ Edytuj</button>
          <button onClick={() => del(a)} style={{ ...btn, color: '#b91c1c', borderColor: '#fecdd3' }}>Usuń</button>
        </div>
      ))}
      <div style={{ marginTop: 12, padding: '10px 12px', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 8 }}>
        <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 8 }}>{form.id ? 'Edycja konta' : 'Nowe konto'}</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
          <input value={form.number} onChange={(e) => setForm({ ...form, number: e.target.value })} placeholder="Numer konta (26 cyfr) albo IBAN" style={{ ...inp, flex: '2 1 260px', fontFamily: 'monospace' }} />
          <input value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} placeholder="Krótki opis, np. mBank PLN — główne" maxLength={120} style={{ ...inp, flex: '1 1 200px' }} />
          <label style={{ fontSize: 12, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}>
            <input type="checkbox" checked={form.is_default} onChange={(e) => setForm({ ...form, is_default: e.target.checked })} /> domyślne
          </label>
          <button onClick={save} disabled={busy} style={{ ...btn, background: '#1d4ed8', color: '#fff', borderColor: '#1d4ed8', opacity: busy ? 0.6 : 1 }}>{form.id ? 'Zapisz zmiany' : '＋ Dodaj konto'}</button>
          {form.id ? <button onClick={() => { reset(); setMsg(null); }} style={btn}>Anuluj</button> : null}
          {msg ? <span style={{ fontSize: 12, fontWeight: 600, color: msg.ok ? '#15803d' : '#b91c1c' }}>{msg.text}</span> : null}
        </div>
      </div>
    </div>
  );
}
